import Default from './DefaultTemplate';

export default Default;
